module.exports = __webpack_public_path__ + "img/type_GROUND.df8900f0.png";